module.exports = __webpack_public_path__ + "img/briefcase.68291d7d.svg";